import React from 'react';
import { PropTypes } from 'prop-types';
import { TorgaContext } from '../TorgaContext';
import GoalForm from './GoalForm';
import { actionGoalCreate, actionGoalUpdate } from './actions';
import { Button, NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Link } from 'react-router-dom';
import { urlToGoalID } from '../TorgaRouter';

export default function GoalList({ activityID }) {
  const { state, dispatchAction } = React.useContext(TorgaContext);
  const [selectedGoalID, setSelectedGoalID] = React.useState('');
  const [search, setSearch] = React.useState('');
  const numericActivityID = Number(activityID);

  const goals = state.goals.allIDs
    .map((id) => state.goals.byID[id])
    .filter((goal) => goal && !goal.deleted)
    .filter((goal) => Number(goal.activity_id) === numericActivityID);

  const availableGoals = state.goals.allIDs
    .map((id) => state.goals.byID[id])
    .filter((goal) => goal && !goal.deleted)
    .filter((goal) => Number(goal.activity_id) !== numericActivityID)
    .filter((goal) => {
      if (!search.trim()) {
        return true;
      }
      return String(goal.name || '')
        .toLowerCase()
        .includes(search.toLowerCase());
    });

  return (
    <div>
      <h3>Goals</h3>
      {goals.map((goal) => (
        <div
          key={goal.id}
          style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}
        >
          <Link to={urlToGoalID(goal.id)}>{goal.name}</Link>
          <Button
            icon={IconNames.REMOVE}
            minimal
            onClick={() => dispatchAction(actionGoalUpdate(goal.id, 'activity_id', null))}
          />
        </div>
      ))}

      {goals.length === 0 && (
        <NonIdealState
          icon={IconNames.TARGET}
          description={
            'No goal is set yet for this activity, explore goals below or add a custom one.'
          }
        />
      )}

      <div style={{ marginBottom: 8 }}>
        <input
          type="text"
          placeholder="Search goal..."
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          style={{ width: '100%', padding: 8 }}
        />
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
        <select
          style={{ flex: 1 }}
          value={selectedGoalID}
          onChange={(event) => setSelectedGoalID(event.target.value)}
        >
          <option value="">Link existing goal...</option>
          {availableGoals.map((goal) => (
            <option key={goal.id} value={goal.id}>
              G{goal.id} - {goal.name}
            </option>
          ))}
        </select>
        <Button
          disabled={!selectedGoalID}
          icon={IconNames.ADD}
          onClick={() => {
            dispatchAction(
              actionGoalUpdate(
                Number(selectedGoalID),
                'activity_id',
                Number(activityID)
              )
            );
            setSelectedGoalID('');
          }}
        >
          Associate goal
        </Button>
      </div>

      <GoalForm
        onCreate={(goal) => {
          dispatchAction(actionGoalCreate(goal.name, activityID));
        }}
      />
    </div>
  );
}

GoalList.propTypes = {
  activityID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
